import React from 'react';
import { makeStyles } from '@material-ui/core';
import intl from 'react-intl-universal';

const useStyles = makeStyles(() => ({
  section: {
    maxWidth: '28rem',
  },
  heading: {
    fontSize: '2.375rem',
    margin: 0,
    '@media (max-width: 50rem)': {
      fontSize: '2rem',
      textAlign: 'center',
    },
  },
  paragraph: {
    fontSize: '1.125rem',
    letterSpacing: '0.2px',
    lineHeight: 1.5,
    '@media (max-width: 50rem)': {
      textAlign: 'justify',
    },
  },
  link: {
    fontWeight: 600,
    textDecoration: 'none',
  },
  boldParagraph: {
    fontWeight: 600,
  },
}));

export default function Welcome() {
  const classes = useStyles();
  return (
    <section className={classes.section}>
      <h1 className={classes.heading}>{intl.get('components.Welcome.welcomeToLifesize')}</h1>
      <p className={classes.paragraph}>{intl.get('components.Welcome.accountCreated')}</p>
      <p className={classes.boldParagraph}>
        {intl.get('components.Welcome.complimentaryClose')}
        <br />
        {intl.get('components.Welcome.teamSignature')}
      </p>
    </section>
  );
}
